import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface IEsOtpOption {
    type: string;
    info: string | number;
    startIcon: React.ReactElement;
    selected?: boolean;
    onClick?: VoidFunction;
    disabled?: boolean;
}

const OTPOption: React.FC<IEsOtpOption> = ({ type, info, startIcon, selected, onClick, disabled }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            <Button
                onClick={onClick}
                disabled={disabled}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    backgroundColor: disabled
                        ? `${theme[themeStyle].signUpGrey}80` // Add transparency when disabled
                        : theme[themeStyle].signUpGrey,
                    borderRadius: 3,
                    mb: 1,
                    ...(selected && { border: `2px solid ${theme[themeStyle].tag_white}` }),
                    opacity: disabled ? 0.6 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }}
                startIcon={startIcon}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                    }}>
                    <Typography
                        sx={{
                            textTransform: 'none',
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            fontSize: '14px',
                            color: theme[themeStyle].form_label,
                        }}>
                        via {type}
                    </Typography>

                    <Typography
                        sx={{
                            textTransform: 'none',
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            fontSize: '14px',
                            color: theme[themeStyle].tag_white,
                        }}>
                        {info}
                    </Typography>
                </Box>
            </Button>

            {disabled && (
                <LockOutlinedIcon
                    fontSize="small"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: theme[themeStyle].form_label,
                    }}
                />
            )}
        </Box>
    );
};

export { OTPOption };
